export class WebshopService {
  private static BASE_URL = "/api";

  static async getCustomerSubscription(stripeSubscriptionId: string) {
    const res = await fetch(
      `${this.BASE_URL}/webshop/customer-subscription?stripeSubscriptionId=${stripeSubscriptionId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    return res.json();
  }

  static async getSubscriptions(locale: string, currency: string) {
    const res = await fetch(
      `${this.BASE_URL}/webshop/subscriptions?locale=${locale}&currency=${currency}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    return res.json();
  }

  static async calculateOrderSummaryForItems(items: any, currency: string) {
    const res = await fetch(`${this.BASE_URL}/webshop/order-summary`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        currency,
        items
      })
    });

    return res.json();
  }

  static async getStripeConfiguration() {
    const res = await fetch(`${this.BASE_URL}/webshop/configuration`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    return res.json();
  }

  static async updateSubscription(
    subscriptionId: string,
    customerEmail: string,
    items: any
  ) {
    const res = await fetch(`${this.BASE_URL}/webshop/update-subscription`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        subscriptionId,
        customerEmail,
        items
      })
    });
    return res.json();
  }

  static async cancelSubscription(subscriptionId: string) {
    const res = await fetch(`${this.BASE_URL}/webshop/cancel-subscription`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        subscriptionId
      })
    });
    return res.json();
  }

  static async createCheckoutSession(
    languageCode: string,
    customerEmail: string,
    existingUser: boolean,
    items: any,
    couponCode?: string
  ) {
    const res = await fetch(`${this.BASE_URL}/webshop/checkout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        siteLanguageCode: languageCode,
        customerEmail,
        existingUser,
        items,
        couponCode
      })
    });

    return res.json();
  }

  static async validateCoupon(couponCode: string) {
    const res = await fetch(`${this.BASE_URL}/webshop/validate-coupon`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        couponCode
      })
    });

    return res.json();
  }
}
